import { Component, EventEmitter, Input, OnInit, Output, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastsManager } from 'ng2-toastr';
import { Observable } from 'rxjs/Observable';
import { IPagedResults } from '../../core/interfaces';
import { IncidentTypeService } from '../../services/incident-type.service';
import { modalCreateType } from '../../shared/modules/dialogOptions';
import { IncidentTypesEditComponent } from './incident-types-edit.component';

@Component({
    selector: 'app-incident-types-list',
    templateUrl: './incident-types-list.component.html',
    styleUrls: ['./incident-types-list.component.scss']
})
export class IncidentTypesListComponent implements OnInit {
    deleteId: any;
    public showSpinner: boolean = false;
    @Output()
    DeletedType1 = new EventEmitter<any>();
    @Input() filter: number = 0
    public itemPerPage: number = 10;
    modalReference: NgbModalRef;
    public currentPage: number = 1;
    public totalItems: number = 10;
    public isAdminOrUserEditor = false;
    public isSuperAdmin = false; 5
    public isPreviewOn: boolean = false;
    //public parentComponent : any;
    constructor(
        //private parentInj: Injector,
        private router: Router,
        private route: ActivatedRoute,
        private modalService: NgbModal,
        private toastr: ToastsManager,
        private incidentTypeService: IncidentTypeService,
        private vRef: ViewContainerRef) {
        this.toastr.setRootViewContainerRef(vRef)
        // this.parentComponent = this.parentInj.get(IncidentTypesComponent);
    }
    packageData: any[];

    ngOnInit() {
        if (this.isSuperAdmin) {
            this.loadData();
        }
    }

    public loadData(page?: number, id?: number) {
        this.showSpinner = true;
        let filter = '';
        if (page != null) {
            this.currentPage = page;
        }
        var user = JSON.parse(localStorage.getItem('currentUser'));
        var SiteId = +localStorage.getItem('IncidentcurrentSiteId');
        this.incidentTypeService.getAllIncidentTypes(user.accountId, SiteId, false)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: IPagedResults<any>) => {
                this.packageData = (response.Data);
                this.totalItems = response.Data.length;
                // this.toastr.success(response.Message, "Success"); 
            });
    }

    get siteId() {
        return +localStorage.getItem('IncidentcurrentSiteId')
    }

    public loadDataById(id: number) {
        this.showSpinner = true;
        var user = JSON.parse(localStorage.getItem('currentUser'));
        this.incidentTypeService.getAllIncidentTypes(user.accountId, this.siteId, false)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: IPagedResults<any>) => {
                this.packageData = response.Data;
                this.totalItems = response.Data.length;
                // this.toastr.success(response.Message, "Success"); 
            });
    }

    public editIncidentType(id: number) {

        const modalRef = this.modalService.open(IncidentTypesEditComponent, modalCreateType);
        modalRef.componentInstance.modalIdData = id;
        modalRef.result.then((result) => {
            this.ngOnInit();
            //alert(result);
            this.loadDataById(result);
        }, (reason) => {
            this.ngOnInit();
            // alert(reason +"aaa");
        });
        // this.router.navigate([`${id}/edit`], { relativeTo: this.route });  
    }
    openLg(content, id) {
        this.deleteId = id;
        this.modalReference = this.modalService.open(content);
    }

    public toggleIsActive(id: number, name: string, value: boolean) {
        this.incidentTypeService.toggleIsActive(id, this.siteId, value).subscribe((res: any) => {
            this.toastr.success(`${name} was ${(value ? "enabled" : "disabled")} successfully`, "Success");
            this.loadData()
        })
    }

    public deletType1(id: number) {
        //alert(id);
        this.incidentTypeService.deleteIncidentType(id).catch((err: any) => {
            return Observable.throw(err);
        })
            .finally(() => {
                setTimeout(() => {
                }, 1000);
            })
            .subscribe((response: any) => {
                if (response.Success) {
                    this.toastr.success(response.Message, "Success");
                } else {
                    this.toastr.error(response.Message, "Cannot delete");
                }
                this.modalReference.close();
                // this.ngOnInit();
                this.DeletedType1.emit({ GuardId: id });
            });

    };

    get filteredList() {
        var list = this.packageData
        if (this.filter > 0) {
            return list.filter(e => (this.filter == 1 && e.IsActive) || (this.filter == 2 && !e.IsActive))
        }

        return list
    }

}



// WEBPACK FOOTER //
// ./src/app/components/incident-types/incident-types-list.component.ts